/* Duskhaven 2.7: full-screen photo button on every variant card (product page).
   Adds a small orange expand icon right above the first letter of each variant's name; it opens a swipeable full-screen
   view of that option's variant photos, starting on the one tapped. Horizon re-renders the cards on every change, so a
   MutationObserver puts the buttons back. The button is not part of the radio: clicking it never changes the selected variant.
   Horizon lays an invisible <iframe> and the real radio <input> over each card, so they catch the pointer before the icon
   does. The click handler therefore also works from the click's coordinates: a click that lands on the icon's box
   (plus a few px) counts as a click on the icon, whatever element is on top.
   2026-10-09 (Todd): place() puts the previous/next arrows outside the photo on its left and right, centred on the photo's
   height, and the close X above the photo, outside its top-right corner. It measures the displayed photo (width, height and the
   slide's padding) and re-runs on every photo change, photo load and resize. */
(function () {
  if (window.__dhVzoom) return;
  window.__dhVzoom = true;
  var ICON = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5"/></svg>';
  var PAD = 6;
  var GAP = 12, NAV = 48, XSZ = 44, EDGE = 8;
  var dlg, track, caption, idxEl, items = [], cur = 0, lastFocus;

  function big(src) {
    try { var u = new URL(src, location.href); u.searchParams.set('width', '1600'); u.searchParams.delete('height'); return u.toString(); } catch (e) { return src; }
  }
  function labelText(card) {
    var t = card.querySelector('.dh-vcard__label');
    return t ? t.textContent.trim() : '';
  }
  function decorate(root) {
    (root || document).querySelectorAll('.dh-vcard').forEach(function (card) {
      if (card.querySelector('.dh-vzoom')) return;
      var img = card.querySelector('.dh-vcard__img');
      if (!img) return;
      var b = document.createElement('span');
      b.className = 'dh-vzoom';
      b.setAttribute('role', 'button');
      b.tabIndex = 0;
      b.setAttribute('aria-label', 'View ' + labelText(card) + ' photo full screen');
      b.innerHTML = ICON;
      (card.querySelector('.dh-vcard__text') || card).appendChild(b);
    });
  }
  function zoomAt(x, y) {
    var all = document.querySelectorAll('.dh-vzoom');
    for (var i = 0; i < all.length; i++) {
      var r = all[i].getBoundingClientRect();
      if (!r.width) continue;
      if (x >= r.left - PAD && x <= r.right + PAD && y >= r.top - PAD && y <= r.bottom + PAD) return all[i];
    }
    return null;
  }
  /* Put the arrows and the X next to the photo that is on screen (see the note at the top). */
  function place() {
    if (!dlg || !dlg.open || !track || !items.length) return;
    var slide = track.children[cur];
    var im = slide && slide.querySelector('img');
    if (!im || !im.offsetWidth || !im.offsetHeight) return;
    var W = track.clientWidth, H = track.clientHeight;
    var cs = getComputedStyle(slide);
    var pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0;
    var iw = im.offsetWidth, ih = im.offsetHeight;
    var left = (W - iw) / 2;
    var top = pt + Math.max(0, (H - pt - pb - ih) / 2);
    var closeBtn = dlg.querySelector('.dh-vzoom-close');
    var prev = dlg.querySelector('.dh-vzoom-prev');
    var next = dlg.querySelector('.dh-vzoom-next');
    closeBtn.style.right = Math.max(EDGE, W - (left + iw)) + 'px';
    closeBtn.style.top = Math.max(EDGE, top - GAP - XSZ) + 'px';
    if (getComputedStyle(prev).display === 'none') return;
    var midY = top + ih / 2;
    prev.style.top = (midY - NAV / 2) + 'px';
    next.style.top = (midY - NAV / 2) + 'px';
    prev.style.left = Math.max(EDGE, left - GAP - NAV) + 'px';
    next.style.right = Math.max(EDGE, W - (left + iw) - GAP - NAV) + 'px';
  }
  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'dh-vzoom-dlg';
    dlg.setAttribute('aria-label', 'Full screen photos');
    dlg.innerHTML = '<button type="button" class="dh-vzoom-close" aria-label="Close full screen">&times;</button>' +
      '<button type="button" class="dh-vzoom-nav dh-vzoom-prev" aria-label="Previous photo">&#8249;</button>' +
      '<div class="dh-vzoom-track"></div>' +
      '<button type="button" class="dh-vzoom-nav dh-vzoom-next" aria-label="Next photo">&#8250;</button>' +
      '<div class="dh-vzoom-cap"><span class="dh-vzoom-name"></span><span class="dh-vzoom-idx"></span></div>';
    document.body.appendChild(dlg);
    track = dlg.querySelector('.dh-vzoom-track');
    caption = dlg.querySelector('.dh-vzoom-name');
    idxEl = dlg.querySelector('.dh-vzoom-idx');
    dlg.querySelector('.dh-vzoom-close').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('.dh-vzoom-prev').addEventListener('click', function () { go(cur - 1); });
    dlg.querySelector('.dh-vzoom-next').addEventListener('click', function () { go(cur + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target === track) dlg.close(); });
    dlg.addEventListener('close', function () { document.documentElement.classList.remove('dh-vzoom-open'); if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} } });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(cur - 1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { go(cur + 1); e.preventDefault(); }
    });
    window.addEventListener('resize', place);
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== cur && i >= 0 && i < items.length) { cur = i; label(); }
      }, 60);
    }, { passive: true });
  }
  function label() {
    caption.textContent = items[cur] ? items[cur].name : '';
    idxEl.textContent = items.length > 1 ? (cur + 1) + ' / ' + items.length : '';
    dlg.classList.toggle('is-single', items.length < 2);
    dlg.querySelector('.dh-vzoom-prev').disabled = cur <= 0;
    dlg.querySelector('.dh-vzoom-next').disabled = cur >= items.length - 1;
    place();
  }
  function go(i) {
    if (i < 0 || i >= items.length) return;
    cur = i;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({ left: i * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    label();
  }
  function open(btn) {
    var card = btn.closest('.dh-vcard');
    var set = card.closest('fieldset') || document;
    var seen = {};
    items = [];
    var start = 0;
    set.querySelectorAll('.dh-vcard').forEach(function (c) {
      var img = c.querySelector('.dh-vcard__img');
      if (!img) return;
      var src = big(img.currentSrc || img.src);
      var key = src.split('?')[0];
      if (c === card) start = seen[key] !== undefined ? seen[key] : items.length;
      if (seen[key] !== undefined) return;
      seen[key] = items.length;
      items.push({ src: src, name: labelText(c) });
    });
    if (!dlg) build();
    track.innerHTML = '';
    items.forEach(function (it, n) {
      var s = document.createElement('div');
      s.className = 'dh-vzoom-slide';
      var im = document.createElement('img');
      im.alt = it.name;
      im.decoding = 'async';
      if (Math.abs(n - start) > 1) im.loading = 'lazy';
      im.addEventListener('load', place);
      im.src = it.src;
      s.appendChild(im);
      track.appendChild(s);
    });
    lastFocus = btn;
    document.documentElement.classList.add('dh-vzoom-open');
    if (!dlg.open) dlg.showModal();
    cur = start;
    track.scrollTo({ left: start * track.clientWidth, behavior: 'auto' });
    label();
    dlg.querySelector('.dh-vzoom-close').focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    if (dlg && dlg.open) return;
    var b = e.target.closest && e.target.closest('.dh-vzoom');
    if (!b && e.target.closest && e.target.closest('.dh-vcard')) b = zoomAt(e.clientX, e.clientY);
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    open(b);
  }, true);
  document.addEventListener('mousemove', function (e) {
    var over = e.target.closest && e.target.closest('.dh-vcard') && zoomAt(e.clientX, e.clientY);
    var card = e.target.closest && e.target.closest('.dh-vcard');
    if (card) card.style.cursor = over ? 'zoom-in' : '';
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    var b = e.target.closest && e.target.closest('.dh-vzoom');
    if (b && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); e.stopPropagation(); open(b); }
  }, true);
  function init() {
    decorate(document);
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      requestAnimationFrame(function () { pending = false; decorate(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();